module.exports = __webpack_public_path__ + "static/bottle_bubble_6-67fe3c634dbb6c0dc02137ff9db4da26.mp4";